import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bf3fcf5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview-panel" }
const _hoisted_2 = { class: "pdf-viewer" }
const _hoisted_3 = {
  key: 0,
  class: "skeleton-preview"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"skeleton-page\" data-v-6bf3fcf5><div class=\"skeleton-content\" data-v-6bf3fcf5><div class=\"skeleton-line-title\" data-v-6bf3fcf5></div><div class=\"skeleton-line-subtitle\" data-v-6bf3fcf5></div><div class=\"skeleton-line-subheading\" data-v-6bf3fcf5></div><div class=\"skeleton-line\" data-v-6bf3fcf5></div><div class=\"skeleton-line\" data-v-6bf3fcf5></div><div class=\"skeleton-line\" data-v-6bf3fcf5></div><div class=\"skeleton-line\" data-v-6bf3fcf5></div><div class=\"skeleton-line-subheading\" data-v-6bf3fcf5></div><div class=\"skeleton-line\" data-v-6bf3fcf5></div><div class=\"skeleton-line\" data-v-6bf3fcf5></div><div class=\"skeleton-line\" data-v-6bf3fcf5></div><div class=\"skeleton-line\" style=\"width:70%;\" data-v-6bf3fcf5></div><div class=\"skeleton-line\" style=\"width:80%;\" data-v-6bf3fcf5></div><div class=\"skeleton-line\" style=\"width:60%;\" data-v-6bf3fcf5></div></div></div>", 1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "pdf-content"
}
const _hoisted_7 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"32px","background-color":"#f8f9fa"} }, null, -1))

import VuePdfEmbed from "vue-pdf-embed";


export default /*#__PURE__*/_defineComponent({
  __name: 'PdfPreview',
  props: {
    loading: { type: Boolean },
    pdfUrl: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading && !_ctx.pdfUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.loading && _ctx.pdfUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : _createCommentVNode("", true),
            (_ctx.pdfUrl)
              ? (_openBlock(), _createBlock(_unref(VuePdfEmbed), {
                  key: 1,
                  source: _ctx.pdfUrl,
                  "text-layer": true,
                  class: _normalizeClass(["pdf-embed", { 'loading': _ctx.loading }])
                }, {
                  "after-page": _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["source", "class"]))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}
}

})